import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { PriceMatrixStates } from './price-matrix.states';

@NgModule({
  imports: [
    UIRouterUpgradeModule.forChild({ states: PriceMatrixStates })
  ]
})
export class PriceMatrixModule {}
